// Stub for @magento/peregrine/lib/context/user
import { createContext, useContext } from 'react';

const UserContext = createContext([
    {
        currentUser: {
            email: null,
            firstname: null,
            lastname: null
        },
        isSignedIn: false
    },
    {
        getUserDetails: () => {},
        setToken: () => {}
    }
]);

export const useUserContext = () => useContext(UserContext);

export const UserContextProvider = UserContext.Provider;

export default UserContext;
